import React from "react";

/**
 * A rotating circular "sticker" fixed to the bottom-right of the viewport.
 * Cartoonish, branded, and always-present — a tiny delightful mark that
 * Spin Labs is behind the product. Hidden on mobile to avoid clutter.
 */
export default function SpinBadge() {
  return (
    <div
      className="fixed bottom-6 right-6 z-40 pointer-events-none hidden lg:block"
      aria-hidden
    >
      <div className="relative w-28 h-28">
        <svg
          viewBox="0 0 100 100"
          className="w-full h-full animate-[spin_14s_linear_infinite]"
        >
          <defs>
            <path
              id="badge-path"
              d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0"
              fill="none"
            />
          </defs>
          <circle
            cx="50"
            cy="50"
            r="46"
            fill="none"
            stroke="rgba(0, 240, 255, 0.25)"
            strokeWidth="0.6"
            strokeDasharray="2 3"
          />
          <text
            fontFamily="JetBrains Mono, monospace"
            fontSize="9"
            fontWeight="700"
            letterSpacing="4"
            fill="#00F0FF"
          >
            <textPath href="#badge-path" startOffset="0">
              SPIN · LABS · DELHI · SHIP · SPIN · LABS · DELHI · SHIP ·
            </textPath>
          </text>
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-11 h-11 rounded-full bg-[#050505] border border-[#00F0FF]/40 flex items-center justify-center shadow-[0_0_24px_rgba(0,240,255,0.35)] animate-pulse-glow">
            <svg
              viewBox="0 0 24 24"
              className="w-5 h-5 text-[#00F0FF]"
              fill="currentColor"
            >
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
